import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { getCategoryAndProductId, getExperienceProductIdFromProvider } from 'analytics/snowplow/helpers/itemCategorisation'
import { getExperienceById } from 'api/experiences'
import sanitizeItemContextMetadata from './sanitizeItemContextMetadata'
import { getPlaceByLatLong } from 'api/search'
import { mapCityLevelPlace } from 'lib/search/mappingUtils'

async function getExperienceOrderItems(state: App.State, order: App.Order, isMultiCart?: boolean) {
  const orderItems = [...order.experienceItems, ...order.transferItems]
  return await Promise.all(orderItems.map(async orderItem => {
    let fullOffer = state.experience.experiences[orderItem?.experienceId]
    if (!fullOffer) {
      fullOffer = await getExperienceById(orderItem.experienceId, {
        currentCurrency: order.currencyCode,
        currentRegionCode: order.regionCode,
        airports: state.geo.airports,
      })
    }
    const { categoryId, productId } = getCategoryAndProductId(fullOffer.parentType, fullOffer)
    const finalProductId = getExperienceProductIdFromProvider(fullOffer.provider) || productId
    const locations = mapCityLevelPlace((await getPlaceByLatLong(fullOffer.location.latitude, fullOffer.location.longitude)))
    const destinationCity = locations?.city
    const originCity = locations?.city
    const destinationCountry = locations?.country
    const originCountry = locations?.country
    return comluxgroup.createItem_1_1_0(
      {
        offerId: orderItem.experienceId,
        categoryId,
        productId: finalProductId,
        duration: 1,
        travelStart: orderItem.date,
        travelEnd: orderItem.date,
        price: orderItem.total,
        offerLeadPrice: fullOffer.price,
        offerLeadDuration: '1',
        offerLeadUnit: fullOffer.ticketUnitLabel,
        currency: order.currencyCode,
        destinationCity,
        destinationCountry,
        originCity,
        originCountry,
        itemId: orderItem.id,
        bookingNumber: order.bookingNumber,
        orderId: order.id,
        metadata: sanitizeItemContextMetadata({
          isMultiCart,
        }),
      },
    )
  },
  ))
}

export default getExperienceOrderItems
